export enum Locales {
  RU_RU = 'ru-RU',
  EN_GB = 'en-GB',
}

export enum Resources {
  LOGIN = 'login',
  MAIN_ASIDE = 'mainAside',
  COMMON = 'common',
  CHAT = 'chat',
  CALLS = 'calls',
  ACCOUNT = 'account',
  CONFIDENTIALITY = 'confidentiality',
  GENERAL = 'general',
  SOUND_AND_VIDEO = 'soundAndVideo',
  CALLS_SETTINGS = 'callsSettings',
  TERMINALS = 'terminals',
  NOTIFICATIONS = 'notifications',
  ABOUT = 'about',
  GUEST = 'guest',
  PROFILE = 'profile',
  ERRORS = 'errors'
}

export interface LocalizationItem {
  [key: string]: string
}
export interface LocalizationResource {
  [key: string]: LocalizationItem
}

export type LocalizationResources = {
  [key: string]: LocalizationResource
}

export interface Localization {
  resources: LocalizationResources
}
